import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';
import { authAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#E8F4FD] flex items-center justify-center py-12 px-4" data-testid="forgot-password-page">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex">
            <img src="/assets/padsmash_logo_main.png" alt="PadSmash" className="h-24 sm:h-28 w-auto mx-auto" />
          </Link>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#D6E8F0]">
          {sent ? (
            <div className="text-center" data-testid="forgot-password-sent">
              <CheckCircle className="w-16 h-16 text-[#32CD32] mx-auto mb-4" />
              <h1 className="font-display text-2xl font-bold text-[#033871] mb-2">Email envoyé !</h1>
              <p className="text-[#5A8BA8] mb-6">Si un compte existe avec l'adresse <strong>{email}</strong>, vous recevrez un lien de réinitialisation.</p>
              <p className="text-xs text-[#B8D4E3]">Vérifiez aussi vos spams.</p>
              <Link to="/login">
                <Button variant="outline" className="mt-6 gap-2">
                  <ArrowLeft className="w-4 h-4" /> Retour à la connexion
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-display text-2xl font-bold text-[#033871] mb-2">Mot de passe oublié</h1>
              <p className="text-[#5A8BA8] mb-6">Entrez votre email et nous vous enverrons un lien de réinitialisation.</p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@email.com"
                    className="mt-2"
                    required
                    data-testid="forgot-email"
                  />
                </div>

                <Button type="submit" className="w-full btn-primary h-12" disabled={loading} data-testid="forgot-submit">
                  {loading ? 'Envoi...' : 'Envoyer le lien'}
                  <Mail className="ml-2 w-5 h-5" />
                </Button>
              </form>

              <p className="text-center text-sm text-[#5A8BA8] mt-6">
                <Link to="/login" className="text-[#0C63BF] font-medium hover:underline flex items-center justify-center gap-1">
                  <ArrowLeft className="w-3.5 h-3.5" /> Retour à la connexion
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
